// Supported editor protocol keys; shared without importing React components.
export const TERPENES = [
  'aBisabolol',
  'aEudesmol',
  'aFarnesene',
  'aHumulene',
  'aLimonene',
  'aMyrcene',
  'aPhellandrene',
  'aPinene',
  'aTerpinene',
  'aTerpineol',
  'bCaryophyllene',
  'bEudesmol',
  'bFarnesene',
  'bHumulene',
  'bMyrcene',
  'bOcimene',
  'bPinene',
  'bTerpinene',
  'gTerpinene',
  'borneol',
  'camphene',
  'carene',
  'caryophylleneOxide',
  'cisNerolidol',
  'cisOcimene',
  'dLimonene',
  'eucalyptol',
  'farnesol',
  'fenchol',
  'endoFenchylAlcohol',
  'geraniol',
  'guaiol',
  'limonene',
  'linalool',
  'myrcene',
  'nerol',
  'nerolidol',
  'ocimene',
  'ocimeneIsomer1',
  'ocimeneIsomer2',
  'pMentha15diene',
  'sabinene',
  'sabineneHydrate',
  'squalene',
  'terpineol',
  'terpinolene',
  'transNerolidol',
  'valencene',
  'otherTerpenes',
  'totalTerpenes',
] as const;
